import React from "react";

export default function BirgittesSeveredString() {
  return (
    <>
      <p class="c2">
        <span>
          <p>A silver bow, a severed string,</p>
          <p>A soul adrift, untethered, sing.</p>
          <p>The dream is lost, the thread unwinds,</p>
          <p>A hollow ache, a love confined.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The Pattern weaves, but leaves me bare,</p>
          <p>His shadow lingers everywhere.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Where is he now?</p>
          <p>Does he still see,</p>
          <p>The part of him that lives in me?</p>
          <p>A thousand lives, a bond divine,</p>
          <p>Now torn apart before my time.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The waking world is cold and strange,</p>
          <p>A fleeting face, the years will change.</p>
          <p>But still I search in every gaze,</p>
          <p>For echoes lost in endless haze.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The wheel turns on, its rhythm cruel,</p>
          <p>Yet love still binds me, heart and soul.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Where is he now?</p>
          <p>Does he still see,</p>
          <p>The part of him that lives in me?</p>
          <p>A thousand lives, a bond divine,</p>
          <p>Now torn apart before my time.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>I hear his voice within the wind,</p>
          <p>A ghostly touch, a life that’s pinned.</p>
          <p>No death, no dream, can end this pain,</p>
          <p>I’ll wait until we meet again.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>Where is he now?</p>
          <p>Does he still see,</p>
          <p>The part of him that lives in me?</p>
          <p>A thousand lives, a bond divine,</p>
          <p>Now torn apart before my time.</p>
        </span>
      </p>
      <p class="c2">
        <span>
          <p>The bow will bend, the wheel will spin,</p>
          <p>And someday I will hold him again.</p>
        </span>
      </p>
    </>
  );
}
